













































































































import { Filters } from "@/common/filters.global";
import Sessions from "@/views/customize/data-sources/modals/source-details/Sessions.vue";
import PassivePopup from "@/components/PassivePopup.vue";
import Spinner from "@/components/Spinner.vue";
import {
  ScanSession,
  ScanSessionStatus,
} from "@/views/customize/data-sources/data/model";
import { computed, ref } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  components: { PassivePopup, Spinner, Sessions },
  filters: {
    session_status(status: ScanSessionStatus) {
      switch (status) {
        case "Opened":
          return "Running";
        case "Closed":
          return "Completed";
        case "Cancelled":
          return "Cancelled";
      }
    },
  },
  props: [
    "keep_const",
    "selected_session",
    "has_session_params",
    "set_selected_session",
    "available_sessions",
    "is_loading_sessions",
    "selected_source_application",
  ],
  setup(props, { emit }) {
    const show_popup = ref(false);
    const toggle_popup = () => (show_popup.value = !show_popup.value);

    const set_the_selected_session = (session: ScanSession) => {
      emit("set_selected_session", session);
      toggle_popup();
    };

    const selected_session_display_name = computed(() => {
      //@ts-ignore
      if (props.selected_session.value && props.selected_session.value.id) {
        return `${Filters.date(
          //@ts-ignore
          props.selected_session.value.startTime,
          "ll"
          //@ts-ignore
        )} , ${props.selected_session.value.name}`;
      } else {
        return "Please select a session";
      }
    });
    return {
      toggle_popup,
      show_popup,
      set_the_selected_session,
      selected_session_display_name,
    };
  },
});
